import React, { useState } from 'react';
import { login } from '../services/AuthService';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const data = await login(phone, password);
      // API yanıtı: data.Status ve data.Data.accessToken
      if (data.Status && data.Data?.accessToken) {
        navigate('/', { replace: true });
      } else {
        setError(data.Message || 'Giriş başarısız! Token alınamadı.');
      }
    } catch (err) {
      setError('Hatalı telefon numarası veya şifre.');
      console.error(err);
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: '400px' }}>
      <h2>Yönetici Girişi</h2>
      <form onSubmit={handleLogin}>
        {error && <div className="alert alert-danger">{error}</div>}
        <div className="mb-3">
          <label>Telefon Numarası</label>
          <input
            type="tel"
            className="form-control"
            placeholder="5554443322"
            value={phone}
            onChange={(e) => /^\d*$/.test(e.target.value) && setPhone(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label>Şifre</label>
          <input
            type="password"
            className="form-control"
            placeholder="Şifrenizi giriniz"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary w-100">Giriş Yap</button>
      </form>
    </div>
  );
};

export default Login;